
import React, { useEffect, useState } from 'react'
import { AbstractColumns, getCommonColumns } from '../../CommonUtilities/CommonReactColumn/Commoncolumns';
import { config } from '../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonAxiosGet } from '../../CommonUtilities/CommonAxios/CommonAxios';
import CommonReportComponent from '../../CommonUtilities/CommonReactColumn/CommonReportComponent';
export default function CandidatesRegistrationReport() {
    const [showRegData, setRegData] = useState([]);
    const [showCandidateRegAbstractData,setCandidateRegAbstractData]=useState([])
    const [showDistrictName, setDistrictName] = useState('');
    const [showTypeName, setTypeName] = useState('');
    const [showDrillCount, setDrillCount] = useState();
 const regcandidatecolumns = getCommonColumns({
    getCandidateAbstractData,
    setLabelName: setDistrictName,
    setTypeName,setDrillCount,
    rowIdentifierKey: 'dist_name',
    labelFormatter: (val) => val,
    labelTitle: 'Communication District'
  });
    function getRegCandidateData() {
            let Url = config.url.CONTEXT_READ_URL + "candidates-registration-report"
            CommonAxiosGet(Url).then((res) => {
                if (res?.data?.status === true && res?.data?.scode === "01") {
                    setDrillCount(0);setRegData(res?.data?.data);
                }else { setRegData([]) }}) }
        function getCandidateAbstractData(date,type,distCode,pathvariable) {
            let Url = config.url.CONTEXT_READ_URL + "candidates-registration-report/drill/"+pathvariable+"?date="+date+"&type="+type+"&district="+distCode
            CommonAxiosGet(Url).then((res) => {
                if (res?.data?.status === true && res?.data?.scode === "01") {
                    setDrillCount(1);setCandidateRegAbstractData(res?.data?.data);
                } else {setCandidateRegAbstractData([])}
            })
        }
        useEffect(() => { getRegCandidateData(); }, []);
        function isBackFunction() { setDrillCount(showDrillCount - 1) }
  return (
    <div>
        <CommonReportComponent showDrillCount={showDrillCount} showData={showRegData}showAbstractData={showCandidateRegAbstractData} columns={regcandidatecolumns}
        AbstractColumns={AbstractColumns} level0Heading="Candidates Registration Details" level1Heading={`${showDistrictName}-${showTypeName} Candidates Details`}
        headerNameLevel0={<>Candidates Registration Details</>} headerNameLevel1={<>{`${showDistrictName}-${showTypeName} Candidates Details`}</>}isBackFunction={isBackFunction}
        />
    </div>
  )
}
